import { getErrorMessage } from "Utils/errorUtils";
import { put, takeLatest } from "redux-saga/effects";
import {
  updateTheme,
  updateThemeFailed,
  updateThemeFromAgreement,
  updateThemeSucceeded,
} from "./partnerSlice";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* updatePartner() {
  try {
    yield put(updateThemeSucceeded());
  } catch (e) {
    yield put(
      updateThemeFailed(getErrorMessage(e, "Error updating Partner theme")),
    );
  }
}

export function* partnerSaga(): Generator {
  yield takeLatest([updateTheme, updateThemeFromAgreement], updatePartner);
}
